/**
 * Autoplay vidéo PE — fallback Safari / iOS / mode économie d'énergie.
 * Relance .play() à l'entrée viewport, après scroll reveal, et au premier geste utilisateur.
 */
(function () {
  const VIDEO_SELECTOR = '.pe-hero__video, .pe-sp__video-el';
  const GESTURE_EVENTS = ['scroll', 'click', 'touchstart'];

  function tryPlay(video) {
    if (!video || video.tagName !== 'VIDEO') return;

    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function playAllVideos() {
    document.querySelectorAll(VIDEO_SELECTOR).forEach(tryPlay);
  }

  function bindGestureUnlock() {
    if (window.__peVideoGestureUnlockBound) return;
    window.__peVideoGestureUnlockBound = true;

    let unlocked = false;

    function onFirstGesture() {
      if (unlocked) return;
      unlocked = true;
      playAllVideos();
      GESTURE_EVENTS.forEach(function (eventName) {
        document.removeEventListener(eventName, onFirstGesture);
      });
    }

    GESTURE_EVENTS.forEach(function (eventName) {
      document.addEventListener(eventName, onFirstGesture, { passive: true });
    });
  }

  function bindVideo(video) {
    if (video.dataset.peVideoAutoplayBound === 'true') return;
    video.dataset.peVideoAutoplayBound = 'true';

    tryPlay(video);

    video.addEventListener(
      'loadeddata',
      function () {
        tryPlay(video);
      },
      { once: true }
    );

    if (typeof IntersectionObserver !== 'undefined') {
      const viewportObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              tryPlay(video);
            }
          });
        },
        { threshold: 0.05, rootMargin: '0px 0px 10% 0px' }
      );

      viewportObserver.observe(video);
    }

    if (typeof MutationObserver !== 'undefined') {
      const classObserver = new MutationObserver(function () {
        if (
          video.classList.contains('is-revealed') ||
          !video.classList.contains('scroll-reveal')
        ) {
          tryPlay(video);
        }
      });

      classObserver.observe(video, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function scan(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(VIDEO_SELECTOR).forEach(bindVideo);
  }

  window.PeVideoAutoplay = { scan: scan, playAll: playAllVideos };

  bindGestureUnlock();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
